// extracted by mini-css-extract-plugin
export var container = "_ja-0";
export var content = "_ja-3";
export var customerTitle = "_ja-4";
export var empty = "_ja-5";
export var gray = "_ja-6";
export var header = "_ja-7";
export var info = "_ja-8";
export var loading = "_ja-2";
export var loadingCard = "_ja-9";
export var oneLine = "_ja-a";
export var personName = "_ja-e";
export var pillContainer = "_ja-b";
export var selected = "_ja-1";
export var text = "_ja-c";
export var twoLines = "_ja-d";
export var unread = "_ja-f";
export var unreadIndicator = "_ja-g";